import { FC, useState } from "react";

import MintItemToWalletForm from "../MintItemToWalletForm";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Container } from "@mui/material";

import MintItemForm from "sections/itemsPage/MintItemForm";

import InfoBox from "components/InfoBox";
import { INFO_BOX_TYPE } from "components/InfoBox/types";
import MintChoiceSwitch from "components/MintChoiceSwitch";

import { NFC_MINT_TYPES } from "enums/nfcMintTypes";
interface SectionMintProps {
  contractAddress: string;
  nfcContractAddress?: string | null;
  tokenId: number;
  hash: string;
  isPinCodeRequired?: boolean;
  isCards: boolean;
  isNFCMinted?: boolean;
  canMint: boolean;
  isMinting?: boolean;
  description?: string;
  itemName: string;
  nicknameLabel?: string;
  buttonText?: string;
  buttonTextColorHex?: string;
  mintTypes?: NFC_MINT_TYPES[];
}

const SectionMint: FC<SectionMintProps> = ({
  contractAddress,
  nfcContractAddress,
  tokenId,
  hash,
  isPinCodeRequired,
  isNFCMinted = false,
  isCards,
  canMint,
  isMinting,
  description,
  itemName,
  nicknameLabel,
  buttonText,
  mintTypes,
  buttonTextColorHex,
}) => {
  const [value, setValue] = useState(() => {
    if (!mintTypes) {
      return false; // Default to offchain if no mintTypes defined (old items)
    }
    if (mintTypes.includes(NFC_MINT_TYPES.ONCHAIN)) {
      return true; // Prefer 'onchain' if available
    }
    return false; // Default to 'offchain'
  });

  const handleChange = (event: React.SyntheticEvent, newValue: boolean) => {
    setValue(newValue);
  };
  return (
    <Box component="section">
      <Typography paragraph>
        {description ||
          "Enter the wonderful Web 3.0 world by transferring one of the physical minted pieces to the virtual reality. Thanks to blockchain technology, we can reliably confirm the authenticity of the product and prove your ownership of it."}
      </Typography>
      <Box component="section">
        {isMinting && (
          <InfoBox type={INFO_BOX_TYPE.INFO}>
            The item is being minted, refresh the page in a few minutes.
          </InfoBox>
        )}
        {isNFCMinted && !isMinting && (
          <InfoBox type={INFO_BOX_TYPE.SUCCESS}>
            This item has been minted correctly and authenticated on blockchain.
          </InfoBox>
        )}
        {!isNFCMinted && !isMinting && (
          <>
            <Box>
              {(!mintTypes || mintTypes.length > 1) && (
                <MintChoiceSwitch
                  buttonTextColorHex={buttonTextColorHex}
                  disabledLabel="Claim to Email"
                  enabledLabel="Claim to Wallet"
                  switchProps={{
                    checked: value,
                    value: value,
                    onChange: handleChange,
                  }}
                />
              )}
              {value === false && (
                <Container
                  sx={{
                    marginTop: 2,
                  }}
                >
                  <MintItemForm
                    data={{
                      nfcContractAddress,
                      contractAddress,
                      tokenId,
                      hash,
                      itemName,
                    }}
                    isCards={isCards}
                    canMint={canMint}
                    isPinCodeRequired={isPinCodeRequired}
                    nicknameLabel={nicknameLabel}
                    buttonText={buttonText}
                  />
                </Container>
              )}
              {value === true && (
                <Container
                  sx={{
                    marginTop: 2,
                  }}
                >
                  <MintItemToWalletForm
                    data={{
                      nfcContractAddress,
                      contractAddress,
                      tokenId,
                      hash,
                      itemName,
                    }}
                    isCards={isCards}
                    canMint={canMint}
                    isPinCodeRequired={isPinCodeRequired}
                    nicknameLabel={nicknameLabel}
                    buttonText={buttonText}
                  />
                </Container>
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default SectionMint;
